import { ContactChannelOptionType, ContactMethod } from '@shared/utils/enums';
import { ContactCardData, ContactsDetailsDto } from '@shared/utils/interfaces';

export const CHANNEL_CONTACT_METHOD_MAP: Record<ContactChannelOptionType, ContactMethod> = {
  [ContactChannelOptionType.Email]: ContactMethod.Email,
  [ContactChannelOptionType.Phone]: ContactMethod.Phone,
  [ContactChannelOptionType.Telegram]: ContactMethod.Telegram,
  [ContactChannelOptionType.Whatsapp]: ContactMethod.Whatsapp,
  [ContactChannelOptionType.Other]: ContactMethod.Other,
};

export const CHANNEL_LABELS: Record<ContactChannelOptionType, string> = {
  [ContactChannelOptionType.Email]: 'Email',
  [ContactChannelOptionType.Phone]: 'Phone',
  [ContactChannelOptionType.Telegram]: 'Telegram',
  [ContactChannelOptionType.Whatsapp]: 'Whatsapp',
  [ContactChannelOptionType.Other]: 'Other',
};

export const mapContactsToCardData = (contactDetails: ContactsDetailsDto): ContactCardData => {
  return {
    name: `${contactDetails.firstName} ${contactDetails.lastName}`.trim(),
    contactType: contactDetails.position,
    method: contactDetails.channels.map((channel) => ({
      name: CHANNEL_CONTACT_METHOD_MAP[channel.type],
      details: channel.link,
    })),
    id: contactDetails.id!,
  };
};
